import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation, useNavigate } from "react-router-dom";
import { Auth0Features } from "../components/auth0-features";
import { HeroBanner } from "../components/hero-banner";
import { PageLayout } from "../components/PageLayout";
import { isMobile } from "react-device-detect";
import { Auth0FeaturesMobile } from "../components/auth0-features-mobile";
import { ROUTES } from "../config/routes";
import UserService from "../services/UserService";

export const HomePage = () => {
  const { isAuthenticated, loginWithRedirect, getAccessTokenSilently, user } = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is coming from email verification
    const searchParams = new URLSearchParams(location.search);
    const verified = searchParams.get("verified");
    
    // If verified parameter exists and user is not authenticated, automatically log them in
    if (verified === "true" && !isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo: ROUTES.DASHBOARD,
        },
        authorizationParams: {
          prompt: "login",
        },
      });
      return;
    }

    // If user is already authenticated and hits '/', decide where to go based on Stripe subscription
    if (isAuthenticated && user) {
      (async () => {
        try {
          const token = await getAccessTokenSilently();
          const sub = await UserService.getUserSubscription(token, user, true);
          console.log("HomePage: Full subscription response:", JSON.stringify(sub, null, 2));
          console.log("HomePage: sub.status =", sub?.status, "type:", typeof sub?.status);
          console.log("HomePage: sub.subscriptionType =", sub?.subscriptionType);
          console.log("HomePage: sub.subscriptionId =", sub?.subscriptionId);
          console.log("HomePage: sub.allSubSctiptions =", sub?.allSubSctiptions);

          let hasActiveSub = false;
          if (sub) {
            // Primary check: main subscription object
            // Handle both boolean true and truthy values for status
            const statusIsActive = sub.status === true || sub.status === "true" || sub.status === 1;
            const hasValidType = sub.subscriptionType && sub.subscriptionType !== "Default";
            const hasValidId = sub.subscriptionId && String(sub.subscriptionId).trim() !== "";
            
            const mainSubCheck = statusIsActive && hasValidType && hasValidId;
            
            console.log("HomePage: Main subscription check result:", mainSubCheck);
            console.log("HomePage: Breakdown - status:", sub.status, "(type:", typeof sub.status, ")", "type:", sub.subscriptionType, "id:", sub.subscriptionId);
            
            if (mainSubCheck) {
              hasActiveSub = true;
              console.log("HomePage: ✅ Active subscription found in main object:", sub.subscriptionType, "ID:", sub.subscriptionId);
            } else {
              console.log("HomePage: Main object check failed, checking allSubSctiptions...");
              
              // Fallback: look into allSubSctiptions for any active, non-default plan
              if (Array.isArray(sub.allSubSctiptions) && sub.allSubSctiptions.length > 0) {
                console.log("HomePage: Checking allSubSctiptions array (length:", sub.allSubSctiptions.length, ")");
                const activeSub = sub.allSubSctiptions.find(
                  (s) => {
                    if (!s) return false;
                    const sStatusIsActive = s.status === true || s.status === "true" || s.status === 1;
                    const sHasValidType = s.subscriptionType && s.subscriptionType !== "Default";
                    const sHasValidId = s.subscriptionId && String(s.subscriptionId).trim() !== "";
                    const sIsValidPlan = s.subscriptionType === "CoPilot" ||
                      s.subscriptionType === "Silver" ||
                      s.subscriptionType === "Gold" ||
                      s.subscriptionType === "Platinum";
                    
                    return sStatusIsActive && sHasValidType && sHasValidId && sIsValidPlan;
                  }
                );
                if (activeSub) {
                  hasActiveSub = true;
                  console.log("HomePage: ✅ Active subscription found in allSubSctiptions:", activeSub.subscriptionType, "ID:", activeSub.subscriptionId);
                } else {
                  console.log("HomePage: ❌ No active subscription found in allSubSctiptions");
                  // Log each subscription for debugging
                  sub.allSubSctiptions.forEach((s, idx) => {
                    console.log(`HomePage: allSubSctiptions[${idx}]:`, {
                      status: s?.status,
                      subscriptionType: s?.subscriptionType,
                      subscriptionId: s?.subscriptionId
                    });
                  });
                }
              } else {
                console.log("HomePage: ❌ No allSubSctiptions array or it's empty");
              }
            }
          } else {
            console.log("HomePage: ❌ Subscription response is null/undefined");
          }

          console.log("HomePage: Final hasActiveSub =", hasActiveSub);
          console.log("HomePage: Current pathname =", location.pathname);

          // Only redirect if we're not already on the target page
          if (hasActiveSub) {
            if (location.pathname !== ROUTES.DASHBOARD) {
              console.log("HomePage: ✅ Redirecting authenticated user with active sub to Dashboard");
              navigate(ROUTES.DASHBOARD, { replace: true });
            } else {
              console.log("HomePage: Already on Dashboard, skipping redirect");
            }
          } else {
            if (location.pathname !== ROUTES.PRICING) {
              console.log("HomePage: ⚠️ Authenticated user without active sub, redirecting to Pricing");
              navigate(ROUTES.PRICING, { replace: true });
            } else {
              console.log("HomePage: Already on Pricing, skipping redirect");
            }
          }
        } catch (e) {
          console.error("HomePage: Error checking subscription, redirecting to Pricing:", e);
          navigate(ROUTES.PRICING, { replace: true });
        }
      })();
    }
  }, [location.search, isAuthenticated, loginWithRedirect, getAccessTokenSilently, user, navigate]);

    // if (isMobile) {
    //     return (
    //         <PageLayout>
    //             <HeroBanner/>
    //             <Auth0Features/>
    //         </PageLayout>
    //     )
    // }

  return (
    <PageLayout>
      <HeroBanner />
      <Auth0Features />
    </PageLayout>
  );
};


//
//
// import React from "react";
// import { Auth0Features } from "../components/auth0-features";
// import { HeroBanner } from "../components/hero-banner";
// import { PageLayout } from "../components/page-layout";
// import {isMobile} from 'react-device-detect';
// const HomePage = () => {
//     return (
//         <PageLayout>
//             <HeroBanner/>
//             <Auth0Features/>
//         </PageLayout>
//     )
// };
//
// export default HomePage;
